import React from 'react';
import classNames from 'classnames';
import { CommonProps } from 'src/components/helpers/props';

import './index.scss';

const ContentLayout: React.FC<CommonProps> = ({ classes, children }) => {
  return <div className={classNames('content-root', classes)}>{children}</div>;
};
export default ContentLayout;
